import React from 'react';
import styled from 'styled-components';
import { fadeIn, slideUp } from '../styles/animations';
import { RetroLinkButton } from '../styles/RetroButton';

const WinnerContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${fadeIn} 0.5s ease;
`;

const WinnerDialog = styled.div`
  padding: 40px 60px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.2);
  animation: ${slideUp} 0.5s ease-out;
  text-align: center;
  max-width: 400px;
`;

const WinnerMessage = styled.h1`
  font-size: 48px;
  color: #333;
  margin-bottom: 30px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
`;

const WinnerDisplay = ({ winner, isMultiplayer }) => {
  return (
    <WinnerContainer>
      <WinnerDialog>
        <WinnerMessage>{winner} wins!</WinnerMessage>
        <ButtonContainer>
          {/* <RetroLinkButton to={newGamePath}>
            New Game
          </RetroLinkButton> */}
          <RetroLinkButton to="/">
            Main Menu
          </RetroLinkButton>
        </ButtonContainer>
      </WinnerDialog>
    </WinnerContainer>
  );
};

export default WinnerDisplay; 